export const songList = [
        [
        "Azure Window - Waxwork",
        `${process.env.PUBLIC_URL}/songs/Waxwork.mp3`,
        "5:36"
    ],
    [
        "Caliper - Grime",
        `${process.env.PUBLIC_URL}/songs/Grime.mp3`,
        "1:27"
    ],
    [
        "Caliper - Day Off Vibes",
        `${process.env.PUBLIC_URL}/songs/DayOffVibes.mp3`,
        "1:49"
    ],
    [
        "Azure Window - Icy Wanderer",
        `${process.env.PUBLIC_URL}/songs/IcyWanderer.mp3`,
        "3:02"
    ]
];
